import React from "react";
import FormErrorMessage from "Components/Shared/FormComponents/FormErrorMessage/FormErrorMessage";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { Controller, useFormContext } from "react-hook-form";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import pretty from "Shared/pretty";
import { Option } from "Shared/types/Option";
import { useEmployers } from "Hooks/useEmployers";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

export interface SecondaryApproversSelectProps {
  defaultValue: Option[] | null;
}

export const SecondaryApproversSelect = ({ defaultValue }: SecondaryApproversSelectProps) => {
  const { errors, control } = useFormContext<OperatingManagerFormFields>();
  const { employers } = useEmployers();
  const options = employers.map(employer => ({
    value: employer.id,
    label: pretty.fullName(employer.firstName!, employer.lastName!),
  }));

  return (
    <FormField fieldName="Secondary Approver">
      <Controller
        name="secondaryApprovers"
        control={control}
        defaultValue={defaultValue || null}
        rules={{
          validate: {
            required: (value) => value?.length >= 1,
          }
        }}
        options={options}
        maxMenuHeight={80}
        as={
          <DPReactSelect placeholder="Please select" isMulti />
        }
      />
      <FormErrorMessage
        showError={!!errors.secondaryApprovers}
        labelFor="secondaryApprovers"
        message={"Please select secondary approver"}
      />
    </FormField>
  );
};
